import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=a94df0b0"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a94df0b0')) {
      api.createRecord('a94df0b0', component.options)
    } else {
      api.reload('a94df0b0', component.options)
    }
    module.hot.accept("./VideoPlayer.vue?vue&type=template&id=a94df0b0", function () {
      api.rerender('a94df0b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/video/VideoPlayer.vue"
export default component.exports